<script>
    export default {
        data() {
            return {
                items: [],
                total: 0,
                currentPage: 1,
            }
        },
        
        props: {
            url: {
                type: String,
                required: true,
            },
            
            perPage: {
                type: Number,
                default: 25,
            }
        },
        
        watch: {
            currentPage: function () {
                this.loadData();
            }
        },

        render() {
            return this.$scopedSlots.default({
                items: this.items,
                total: this.total,
                pages: this.pages,
                currentPage: this.currentPage,
                setPage: this.setPage,
                nextPage: this.nextPage,
                previousPage: this.previousPage,
            });
        },
        
        created() {
            this.loadData();
        },
        
        computed: {
            pages() {
                return Math.ceil(this.total / this.perPage);
            },
        },
        
        methods: {
            loadData() {
                axios.post(this.url, {
                    perPage: this.perPage,
                    page: this.currentPage,
                }).then(response => {
                    this.items = response.data.items;
                    this.total = response.data.total;
                });
            },
            
            setPage(page) {
                this.currentPage = page;
            },
            
            nextPage() {
                if (this.currentPage === this.pages) return false;
                
                this.currentPage = this.currentPage + 1;
            },
            
            previousPage() {
                if (this.currentPage === 0) return false;
                
                this.currentPage = this.currentPage - 1;
            },
        }
    }
</script>
